import {
    COMPLETE_CHECK_SWID_AUTHENTICATION,
    COMPLETE_CHECK_ONEID_AUTHENTICATION,
    CLEAR_GUEST,
    GET_GUEST,
    LOGIN_START,
    LOGIN_CLOSED
} from '../actions/oneIdActions';

export default function oneIdReducer(state = {}, action) {
    switch (action.type) {
        case COMPLETE_CHECK_SWID_AUTHENTICATION:
            return {
                ...state,
                swid: action.swid,
                isLoggedIn: action.isAuthenticated
            };
        case GET_GUEST:
            return {
                ...state,
                data: action.data,
                completeTime: action.completeTime
            };
        case CLEAR_GUEST:
            return {
                ...state,
                data: {},
                completeTime: undefined
            };
        case LOGIN_START:
            return {
                ...state,
                loginParams: action.params
            };
        case LOGIN_CLOSED:
        case COMPLETE_CHECK_ONEID_AUTHENTICATION:
            return {
                ...state,
                loginParams: undefined
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/oneIdReducer.js